import { afterNextRender, DestroyRef, Directive, ElementRef, inject } from '@angular/core';

import { ClarityFlyInMaxWidths } from './clarity-fly-in-max-widths.service';

/**
 * Marks an element no Clarity fly-in opens wider than. The narrowest marked width is published in px as
 * `--eff-clarity-fly-in-max-inline-size` on the document's root element, measured again whenever a marked element
 * resizes, and removed once the last mark is destroyed. The `ClarityFlyIn` pane, `<eff-clarity-fly-in>` and the System
 * Domain preview fly-in cap their opening width with it and fall back to `100%`; a width the reader drags past it with
 * the resize handle still applies.
 */
@Directive({ selector: '[effClarityFlyInMaxWidth]' })
export class ClarityFlyInMaxWidthDirective {
	private readonly host: HTMLElement = inject<ElementRef<HTMLElement>>(ElementRef).nativeElement;
	private readonly widths = inject(ClarityFlyInMaxWidths);

	private resizeObserver: ResizeObserver | null = null;

	constructor() {
		afterNextRender(() => {
			this.widths.add(this.host);
			this.observe();
		});

		inject(DestroyRef).onDestroy(() => {
			this.resizeObserver?.disconnect();
			this.widths.remove(this.host);
		});
	}

	private observe(): void {
		if (typeof ResizeObserver === 'undefined') {
			return;
		}

		this.resizeObserver = new ResizeObserver(() => this.widths.publish());
		this.resizeObserver.observe(this.host);
	}
}
